<!-- TEMPLATE FOR MODAL COPY WEB QUOTATION QUESTION DIALOG -->
<div class="modal-header">

  <div class="modal-title">
      @if(!createNewVersion) {
          <div class="col-11">
              @if(!isWarranty) {
                <h3>{{isReclaim ? 'Reklamation' : 'Kopiera till ny offert'}}</h3>
              } @else {
                  <h3>Garantiärende</h3>
              }

              @if(!isReclaim && !isWarranty) {
                  <hr />
                  <p>En ny offert skapas med ett nytt offertnummer.<br />Du kan välja att behålla kunduppgifter och/eller prisberäkning från offerten du kopierar ifrån.</p>
              }
          </div>
      }
      @if(createNewVersion) {
          <div class="col-11">
              <h3>Skapa ny version av offerten</h3>
              <br />
              En ny version skapas med ett samma offertnummer och nästa versionsnummer.
              <br />Kunduppgifter och prisberäkning behålls alltid från offerten du skapar ifrån, men du kan skriva ett annat offertnamn.
          </div>
      }
  </div>

  @if(!processing()) {
      <button type="button" class="close" (click)="clickCancel()" aria-label="Close">
          <i title="Stäng" class="fa-regular fa-xmark mr-2"></i>
      </button>
  }

</div>

<!-- BODY -->
<div class="modal-body">

  <!-- COPY FORM -->
  <div class="container-fluid">

      <!-- COPY- / CREATE- FROM  -->
      @if(!isReclaim && !isWarranty) {
          <div class="row">
              <div class="col-12">
                  <h4>{{(createNewVersion ? 'Skapa' : 'Kopiera')}} från</h4>
              </div>
          </div>
      }

      <div class="row mb-3">
          <div class="col-12">
              <ul class="list-group">
                  <!-- OFFERTNR -->
                  <li class="list-group-item pl-0"><strong>Offertnr:</strong> {{copyFromSalesBasketId}}</li>
                  <!-- OFFERT-NAMN -->
                  <li class="list-group-item pl-0"><strong>Offertnamn:</strong> {{(salesBasketVersionName ? salesBasketVersionName : '-')}}</li>
                  <!-- VARUMÄRKE -->
                  @if(enableConversion()) {
                      <li class="list-group-item pl-0">
                          <strong>Invändig profil:</strong>

                          @switch(currentBrand) {
                              @case('SP') {
                                  <span class="font-italic">Rund profil</span>
                              }
                              @case('TR') {
                                  <span class="font-italic">Rak profil</span>
                              }
                              @default {
                                  <span class="font-italic">-</span>
                              }
                          }
                      </li>
                  }
              </ul>
          </div>
      </div>

      <!-- ALTERNATIV -->
      <div class="row">
          <div class="col-12 mb-2">
              <h5 class="mb-2">Alternativ</h5>
              <div class="form-group mb-1">
                  <label for="newQuotationName">Nytt offertnamn</label>
                  <input id="newQuotationName" type="text" class="form-control" placeholder="Ge offerten ett namn" [(ngModel)]="versionName" [disabled]="processing()" />
              </div>
          </div>
          <!--Koppling affärsförslag-->
          @if(hasExternalProjectId) {
          <div class="col-12">
              <h5 class="mb-2">Koppling till affärsförslag</h5>
              <p class="font-italic">
                Affärsförslaget är skapat från ett lead. Det innebär att det finns en koppling mellan affärsförslaget och leadet i
                <span>{{isMF() ? 'planeringsverktyget' : isReseller() ? 'fönsterväljaren' : ''}}</span>
              </p>

              <p class="mb-1">Vill du behålla kopplingen i det nya affärsförslaget?</p>
              <div class="form-group mb-1">
                  <input id="keepExtProjId" type="checkbox" [(ngModel)]="keepExternalProjectId" (ngModelChange)="onKeepExternalProjectIdChange($event, keepExternalProjectId)" [disabled]="processing() || createNewVersion" />
                  <label for="keepExtProjId" class="ml-2">Behåll koppling</label>
              </div>
          </div>
          }
          <!--Reclaim-->
          @if(showReclaim()) {
          <div class="col-12">
              <div class="form-group mb-1">
                  <input id="ckbReclaim" type="checkbox" [(ngModel)]="isReclaim" [disabled]="processing()" />
                  <label for="ckbReclaim" class="ml-2">Reklamation</label>
              </div>
          </div>
          }

          <!--Warranty-->
          @if(showWarrenty()) {
          <div class="col-12">
              <div class="form-group mb-1">
                  <input id="ckbWarranty" type="checkbox" [(ngModel)]="isWarranty" [disabled]="processing()" />
                  <label for="ckbWarranty" class="ml-2">Garantiärende</label>
              </div>
          </div>
          }
      </div>

      <div class="row">

          @if(!isReclaim && !isWarranty) {
          <!--keep customer info-->
          @if(!isMF()) {
            <div class="col-12">
              <div class="form-group mb-1">
                <input id="ckbKeepEndCustomer" type="checkbox" [(ngModel)]="keepEndCustomer" [disabled]="createNewVersion || processing() || keepExternalProjectId" />
                <label for="ckbKeepEndCustomer" class="ml-2">Behåll kunduppgifter</label>
              </div>
            </div>
          }
          <!--keep price calc-->
          <div class="col-12">
              <div class="form-group mb-1">
                  <input id="ckbKeepPrice" type="checkbox" [(ngModel)]="keepPriceCalculation" [disabled]="createNewVersion || processing()" />
                  <label for="ckbKeepPrice" class="ml-2">Behåll prisberäkning</label>
              </div>
          </div>

          @if(isMF()) {
            <!--keep controlmeasure-->
            <div class="col-12">
                <div class="form-group mb-1">
                    <input id="ckbKeepControlMeasure" type="checkbox" [(ngModel)]="keepControlMeasure" [disabled]="createNewVersion || processing()" />
                    <label for="ckbKeepControlMeasure" class="ml-2">Behåll kontrollmätning</label>
                </div>
            </div>

            <!-- mode bookings -->
            @if(usesMontage()) {
              <div class="col-12">
                <div class="form-group mb-1">
                  <input id="ckbMoveBookings" type="checkbox" [(ngModel)]="moveBookings" [disabled]="createNewVersion || processing()" />
                  <label for="ckbMoveBookings" class="ml-2">Flytta bokningar</label>
                  </div>
                </div>
            }
            <!-- keep assembler notes -->
            <div class="col-12">
                <div class="form-group mb-1">
                    <input id="ckbKeepAssemblerNotes" type="checkbox" [(ngModel)]="keepAssemblerNotes" [disabled]="processing()" />
                    <label for="ckbKeepAssemblerNotes" class="ml-2">Behåll noteringar Agent/Mont/Back</label>
                </div>
            </div>

            <!-- keep customer notes -->
            <div class="col-12">
                <div class="form-group mb-1">
                    <input id="ckbKeepCustomerNotes" type="checkbox" [(ngModel)]="keepCustomerNotes" [disabled]="processing()" />
                    <label for="ckbKeepCustomerNotes" class="ml-2">Behåll noteringar Säljare/Kund</label>
                </div>
            </div>
          }

          <!-- copy adjustment items -->
          @if(keepAdjustmentItems) {
            <div class="col-12">
                <div class="form-group mb-1">
                    <input id="ckbKeepAdjustmentItems" type="checkbox" [(ngModel)]="keepAdjustmentItems" [disabled]="createNewVersion || processing()" />
                    <label for="ckbKeepAdjustmentItems" class="ml-2">Inkludera justeringsartiklar</label>
                </div>
            </div>
          }
        }
      </div>

      <div class="row">

          @if(enableConversion() && !isReclaim && !isWarranty) {
            <div class="col-12">
                <hr />
                <h4 class="">Konvertera offert / rader</h4>
            </div>

            <!-- switch outside material-->
            <div class="col-12 mb-2">
                Byt utvändigt material
            </div>
            <div class="col-12">
                <div class="form-group mb-1">
                    <label for="ckbSwitchOutsideMaterialCurrent" class="radio-control ml-2">
                        <input id="ckbSwitchOutsideMaterialCurrent" type="radio" class="mr-2" name="material" [(ngModel)]="switchOutsideMaterial" value="" [disabled]="processing()" /> Behåll nuvarande
                    </label>
                </div>
                <div class="form-group mb-1">
                    <label for="ckbSwitchOutsideMaterialWood" class="radio-control ml-2">
                        <input id="ckbSwitchOutsideMaterialWood" type="radio" class="mr-2" name="material" [(ngModel)]="switchOutsideMaterial" value="SWITCH_TO_WOOD" [disabled]="processing()" /> Byt alla rader med aluminium till trä
                    </label>
                </div>
                <div class="form-group mb-1">
                    <label for="ckbSwitchOutsideMaterialAlu" class="radio-control ml-2">
                        <input id="ckbSwitchOutsideMaterialAlu" type="radio" class="mr-2" name="material" [(ngModel)]="switchOutsideMaterial" value="SWITCH_TO_ALU" [disabled]="processing()" /><div class="d-inline"> Byt alla rader med trä till aluminium <span class="text-danger text-sm">OBS! Kulör på Alu blir STD VIT</span></div>
                    </label>
                </div>
            </div>

            @if(!isReclaim && !isWarranty) {

                  <!-- change brand -->
                  @if(currentBrand ===  'SP' || currentBrand ===  'TR') {
                      <div class="col-12 mb-2">
                          Byt profil
                      </div>
                      <div class="col-12">
                          <div class="form-group mb-1">
                              <label class="radio-control ml-2" for="rbtChangeBrandCurrent">
                                  <input id="rbtChangeBrandCurrent" class="mr-2" type="radio" name="profile" [(ngModel)]="changeToBrand" value="" [disabled]="processing()" />

                                  @if(currentBrand ===  'SP') {
                                      Behåll nuvarande, rund profil
                                  } @if(currentBrand ===  'TR') {
                                      Behåll nuvarande, rak profil
                                  }
                              </label>
                          </div>
                          @if(currentBrand ===  'SP') {
                          <div class="form-group mb-1">
                              <label class="radio-control ml-2" for="rbtChangeBrandTr">
                                  <input id="rbtChangeBrandTr" class="mr-2" type="radio" name="profile" [(ngModel)]="changeToBrand" value="TR" [disabled]="processing()" /> Byt till rak profil
                              </label>
                          </div>
                        }
                        @if(currentBrand ===  'TR') {
                          <div class="form-group mb-1">
                              <label class="radio-control ml-2" for="rbtChangeBrandSp">
                                  <input id="rbtChangeBrandSp" class="mr-2" type="radio" name="profile" [(ngModel)]="changeToBrand" value="SP" [disabled]="processing()" /> Byt till rund profil
                              </label>
                          </div>
                        }
                      </div>
                  }
            }
          }
      </div>

      <!--LINES-->
      @if((isReclaim || isWarranty) && copyFromSalesBasketId !== '') {

      <!--LINES-->
      <div class="row">
          <div class="col-12">
              <h4 class="p-1">Välj rader att reklamera</h4>
          </div>
          <div class="card card-table shadow">
              <div class="col-12 table table-sm">
                  <div class="row row-title mb-2">
                      <div class="col-1">
                          &nbsp;
                      </div>
                      <div class="col-3">
                          Artikel
                      </div>
                      <div class="col-1">
                          Littera
                      </div>
                      <div class="col-2">
                          Mått
                      </div>
                  </div>

                      <div class="w-100" style="max-height:250px; overflow-y:auto; overflow-x:hidden;">
                        @for(item of salesBasketLines; track item) {

                          <div class="row">
                              <div class="col-1">
                                  <strong><input class="ml-2" type="checkbox" [(ngModel)]="item.lineSelected" /></strong>
                              </div>
                              <div class="col-3">
                                  <strong>{{item.CAP_ITEMNAME}}</strong>
                              </div>
                              <div class="col-1">
                                  <strong>{{item.CAP_LETTER}}</strong>
                              </div>
                              <div class="col-2">
                                  <strong>{{item.CAP_SALESWIDTH}}x{{item.CAP_SALESHEIGHT}}</strong>
                              </div>
                              <div class="col-12">
                                  @for(subitem of item.sublines; track $index) {
                                    @if(subitem.InventTable.CAP_CFGGROUPNAME === '') {
                                      <div class="row border-0 p-1">
                                        <div class="col-1 text-right">
                                          <label class="checkbox-control"><input class="mr-3" type="checkbox" [(ngModel)]="subitem.lineSelected" [disabled]="item.lineSelected" /></label>
                                        </div>
                                        <div class="col-4">
                                          {{subitem.CAP_ITEMNAME}}
                                        </div>
                                      </div>
                                    }
                                  }
                              </div>
                          </div>
                        }
                      </div>
                  </div>
              </div>
          </div>
      }
      <!--/END LINES-->
      <!--ERROR-->
      @if(errorMessage){
      <div class="alert alert-danger mt-3" style="white-space: pre-line">
          {{errorMessage}}
      </div>
      }
  </div>
</div>

<!-- FOOTER -->
<div class="modal-footer">

  <div class="row">

      <!-- SPACER -->
      @if(isConverting()) {
          <div class="col-9">
              <div class="alert alert-info shadow">
                  <span>
                      @if(processing()) {
                          <i class="fa-regular fa-spinner fa-lg fa-2x fa-pulse mr-2"></i>
                      }
                      @if(!isUpdatingLineDescriptions()) {
                              Konverterar offerten. Detta kan ta några minuter om det är många rader.
                      } @else {
                          Uppdaterar beskrivningstexter.
                      }
                  </span>
              </div>
          </div>
      }

      <!-- BUTTONS -->
      <div class="col-12">
          @if(!createNewVersion && errorMessage === '') {
              <button class="btn btn-sm btn-primary" (click)="clickOk()" [disabled]="processing() || accessLevel < 1">
                  @if(isReclaim) {
                      <span>Skapa reklamation</span>
                  } @else {
                      <span>Kopiera</span>
                  }

                  @if(processing()) {
                    <span class="ml-2"><i class="fa-regular fa-spinner fa-lg fa-pulse mr-2"></i></span>
                  }
              </button>
          }
          @if(createNewVersion && errorMessage === '') {
              <button class="btn btn-sm btn-primary" (click)="clickOk()" [disabled]="processing() || accessLevel < 1">
                  <span style="white-space:nowrap">Skapa version</span>
              </button>
          }
          @if(errorMessage !== '' || accessLevel < 1) {
              <button class="btn btn-sm btn-primary" (click)="clickCancel()" [disabled]="processing()">Stäng</button>
          }
      </div>
  </div>
</div>
